import { render, staticRenderFns } from "./rateslist.vue?vue&type=template&id=54cd4a53&scoped=true&"
import script from "./rateslist.vue?vue&type=script&lang=js&"
export * from "./rateslist.vue?vue&type=script&lang=js&"
import style0 from "./rateslist.vue?vue&type=style&index=0&id=54cd4a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd4a53",
  null
  
)

export default component.exports